interface InviteLike {
  isFLP?: boolean;
  organization?: { priceBookEntries?: Array<{ productSku?: string }> | null } | null;
}

interface TierLike {
  isStandard?: boolean;
  sku?: string;
  otherVariants?: Array<{ sku?: string }> | null;
}

export const shouldDisableFirmBillingRenewButton = (buttonText: string, hasAicpaFirmBillingFlag: boolean): boolean =>
  buttonText === 'Renew' && hasAicpaFirmBillingFlag;

export const usesInvitingFirmPriceBook = (inviteData?: InviteLike | null): boolean =>
  Boolean(inviteData?.isFLP) && Boolean(inviteData?.organization?.priceBookEntries?.length);

export const isTierInCatalogue = (inviteData?: InviteLike | null, tier?: TierLike | null): boolean => {
  if (!usesInvitingFirmPriceBook(inviteData)) return Boolean(tier?.isStandard);

  const priceBookSkus = (inviteData?.organization?.priceBookEntries ?? []).map(entry => entry?.productSku);
  const tierSkus = [tier?.sku, ...(tier?.otherVariants ?? []).map(variant => variant?.sku)];

  return tierSkus.some(sku => Boolean(sku) && priceBookSkus.includes(sku));
};
